module.exports = __webpack_public_path__ + "static/media/452.df2df97e.webp";